import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Preset } from "@/types";

export function usePresets() {
  return useQuery({
    queryKey: ["presets"],
    queryFn: () => apiFetch<Preset[]>("/api/presets"),
  });
}
